package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class CacheMetaQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun selectValue(key: String): Query<String> = SelectValueQuery(key) { cursor ->
    cursor.getString(0)!!
  }

  public fun upsert(key: String, value_: String) {
    driver.execute(1_976_122_554, """INSERT OR REPLACE INTO CacheMeta(key, value) VALUES (?, ?)""",
        2) {
          bindString(0, key)
          bindString(1, value_)
        }
    notifyQueries(1_976_122_554) { emit ->
      emit("CacheMeta")
    }
  }

  private inner class SelectValueQuery<out T : Any>(
    public val key: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("CacheMeta", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("CacheMeta", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_801_616_086, """SELECT value FROM CacheMeta WHERE key = ?""", mapper,
        1) {
      bindString(0, key)
    }

    override fun toString(): String = "CacheMeta.sq:selectValue"
  }
}
